import type WorkRequestTableViewModel from 'ab-viewModels/workRequestTable.viewModel';

import { WorkRequestBidStatusLabel } from '@acceligentllc/shared/enums/workRequestBidStatus';

const WORK_REQUEST_TABLE_HEADERS = [
	'Bid Status',
	'Priority',
	'Work Request ID',
	'Title',
	'Customer Company',
	'City',
	'State',
	'Office',
	'Project Manager',
	'Start Date',
	'Target Completion Date',
	'Guaranteed Completion Date',
	'Estimate Total',
];

export const toCSVData = (workRequests: WorkRequestTableViewModel[]): string[][] => {

	const headers = WORK_REQUEST_TABLE_HEADERS;
	const rows = workRequests.map((_wr) => {
		return [
			WorkRequestBidStatusLabel[_wr.bidStatus],
			_wr.priority,
			_wr.jobCode,
			_wr.title,
			_wr.customerCompanyName ?? '',
			_wr.city ?? '',
			_wr.state ?? '',
			_wr.office ?? '',
			_wr.projectManager ?? '',
			_wr.startDate ?? '',
			_wr.targetCompletionDate ?? '',
			_wr.guaranteedCompletionDate ?? '',
			_wr.estimateTotal ? `${_wr.estimateTotal}` : '',
		];
	});

	return [headers, ...rows];
};
